"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailedConnectorRequestFormFields = exports.ConnectorHealthStatus = exports.ConnectorStatus = exports.ConnectionType = exports.ConnectorSource = exports.ConnectorTypeLabel = exports.ConnectorType = exports.PlatformType = exports.OtherSoftwareOptions = void 0;
var OtherSoftwareOptions;
(function (OtherSoftwareOptions) {
    OtherSoftwareOptions["Freshbooks"] = "freshbooks";
    OtherSoftwareOptions["Kashflow"] = "kashflow";
    OtherSoftwareOptions["Netsuite"] = "netsuite";
    OtherSoftwareOptions["Other"] = "other";
    OtherSoftwareOptions["Sage"] = "sage";
    OtherSoftwareOptions["Stripe"] = "stripe";
    OtherSoftwareOptions["Wave"] = "wave";
    OtherSoftwareOptions["Zohobooks"] = "zohobooks";
})(OtherSoftwareOptions = exports.OtherSoftwareOptions || (exports.OtherSoftwareOptions = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["AccountingSystem"] = "accounting_system";
    PlatformType["Bank"] = "bank";
    PlatformType["PaymentProcessor"] = "payment_processor";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
var ConnectorType;
(function (ConnectorType) {
    ConnectorType["Affirm"] = "affirm";
    ConnectorType["AgileCRM"] = "agilecrm";
    ConnectorType["AuthorizeNet"] = "authorizenet";
    ConnectorType["Billomat"] = "billomat";
    ConnectorType["BrainTree"] = "braintree";
    ConnectorType["CheckBook"] = "checkbook";
    ConnectorType["ClearBooks"] = "clearbooks";
    ConnectorType["CompanyHub"] = "companyhub";
    ConnectorType["Enigma"] = "enigma";
    ConnectorType["Exact"] = "exact";
    ConnectorType["FastBill"] = "fastbill";
    ConnectorType["Finch"] = "finch";
    ConnectorType["FreshBooks"] = "freshbooks";
    ConnectorType["GoogleAdSense"] = "google_adsense";
    ConnectorType["GoogleAnalytics"] = "google_analytics";
    ConnectorType["Holded"] = "holded";
    ConnectorType["Kizen"] = "kizen";
    ConnectorType["Klarna"] = "klarna";
    ConnectorType["LiftOff"] = "liftoff";
    ConnectorType["MailChimp"] = "mailchimp";
    ConnectorType["MicrosoftDynamics"] = "microsoft_dynamics";
    ConnectorType["MixPanel"] = "mixpanel";
    ConnectorType["Mx"] = "mx";
    ConnectorType["NetSuite"] = "netsuite";
    ConnectorType["Nimble"] = "nimble";
    ConnectorType["PayPal"] = "paypal";
    ConnectorType["PayWhirl"] = "paywhirl";
    ConnectorType["Plaid"] = "plaid";
    ConnectorType["QuickBooks"] = "quickbooks";
    ConnectorType["QuickBooksDesktop"] = "quickbooks_desktop";
    ConnectorType["QuickBooksSandbox"] = "quickbooks_sandbox";
    ConnectorType["Recurly"] = "recurly";
    ConnectorType["RevCent"] = "revcent";
    ConnectorType["Shopify"] = "shopify";
    ConnectorType["Square"] = "square";
    ConnectorType["StoreHippo"] = "storehippo";
    ConnectorType["Stripe"] = "stripe";
    ConnectorType["StripeTest"] = "stripe_test";
    ConnectorType["Swell"] = "swell";
    ConnectorType["Test"] = "test";
    ConnectorType["ThreeDCart"] = "threedcart";
    ConnectorType["UploadedFile"] = "uploaded_file";
    ConnectorType["WorldPay"] = "worldpay";
    ConnectorType["XCart"] = "xcart";
    ConnectorType["Xero"] = "xero";
    ConnectorType["Yodlee"] = "yodlee";
})(ConnectorType = exports.ConnectorType || (exports.ConnectorType = {}));
var ConnectorTypeLabel;
(function (ConnectorTypeLabel) {
    ConnectorTypeLabel["affirm"] = "Affirm";
    ConnectorTypeLabel["agilecrm"] = "AgileCRM";
    ConnectorTypeLabel["authorizenet"] = "AuthorizeNet";
    ConnectorTypeLabel["billomat"] = "Billomat";
    ConnectorTypeLabel["braintree"] = "BrainTree";
    ConnectorTypeLabel["checkbook"] = "CheckBook";
    ConnectorTypeLabel["clearbooks"] = "ClearBooks";
    ConnectorTypeLabel["companyhub"] = "CompanyHub";
    ConnectorTypeLabel["enigma"] = "Enigma";
    ConnectorTypeLabel["exact"] = "Exact";
    ConnectorTypeLabel["fastbill"] = "FastBill";
    ConnectorTypeLabel["finch"] = "Finch";
    ConnectorTypeLabel["freshbooks"] = "FreshBooks";
    ConnectorTypeLabel["google_adsense"] = "GoogleAdSense";
    ConnectorTypeLabel["google_analytics"] = "GoogleAnalytics";
    ConnectorTypeLabel["holded"] = "Holded";
    ConnectorTypeLabel["kizen"] = "Kizen";
    ConnectorTypeLabel["klarna"] = "Klarna";
    ConnectorTypeLabel["liftoff"] = "LiftOff";
    ConnectorTypeLabel["mailchimp"] = "MailChimp";
    ConnectorTypeLabel["microsoft_dynamics"] = "MicrosoftDynamics";
    ConnectorTypeLabel["mixpanel"] = "MixPanel";
    ConnectorTypeLabel["mx"] = "Mx";
    ConnectorTypeLabel["netsuite"] = "NetSuite";
    ConnectorTypeLabel["nimble"] = "Nimble";
    ConnectorTypeLabel["paypal"] = "PayPal";
    ConnectorTypeLabel["paywhirl"] = "PayWhirl";
    ConnectorTypeLabel["plaid"] = "Plaid";
    ConnectorTypeLabel["quickbooks"] = "QuickBooks";
    ConnectorTypeLabel["quickbooks_desktop"] = "QuickBooksDesktop";
    ConnectorTypeLabel["quickbooks_sandbox"] = "QuickBooksSandbox";
    ConnectorTypeLabel["recurly"] = "Recurly";
    ConnectorTypeLabel["revcent"] = "RevCent";
    ConnectorTypeLabel["shopify"] = "Shopify";
    ConnectorTypeLabel["square"] = "Square";
    ConnectorTypeLabel["storehippo"] = "StoreHippo";
    ConnectorTypeLabel["stripe"] = "Stripe";
    ConnectorTypeLabel["stripe_test"] = "StripeTest";
    ConnectorTypeLabel["swell"] = "Swell";
    ConnectorTypeLabel["test"] = "Test";
    ConnectorTypeLabel["threedcart"] = "ThreeDCart";
    ConnectorTypeLabel["uploaded_file"] = "UploadedFile";
    ConnectorTypeLabel["worldpay"] = "WorldPay";
    ConnectorTypeLabel["xcart"] = "XCart";
    ConnectorTypeLabel["xero"] = "Xero";
    ConnectorTypeLabel["yodlee"] = "Yodlee";
})(ConnectorTypeLabel = exports.ConnectorTypeLabel || (exports.ConnectorTypeLabel = {}));
var ConnectorSource;
(function (ConnectorSource) {
    ConnectorSource["AirByte"] = "airbyte";
    ConnectorSource["Capital"] = "capital";
    ConnectorSource["Codat"] = "codat";
})(ConnectorSource = exports.ConnectorSource || (exports.ConnectorSource = {}));
var ConnectionType;
(function (ConnectionType) {
    ConnectionType["Codat"] = "codat";
    ConnectionType["Direct"] = "direct";
    ConnectionType["OAuth"] = "oauth";
})(ConnectionType = exports.ConnectionType || (exports.ConnectionType = {}));
var ConnectorStatus;
(function (ConnectorStatus) {
    ConnectorStatus["Active"] = "active";
    ConnectorStatus["Pending"] = "pending";
    ConnectorStatus["Disconnected"] = "disconnected";
    ConnectorStatus["Deauthorized"] = "deauthorized";
    ConnectorStatus["Authenticating"] = "authenticating";
})(ConnectorStatus = exports.ConnectorStatus || (exports.ConnectorStatus = {}));
var ConnectorHealthStatus;
(function (ConnectorHealthStatus) {
    ConnectorHealthStatus["Pending"] = "pending";
    ConnectorHealthStatus["InitialPullInProgress"] = "initial_pull_in_progress";
    ConnectorHealthStatus["PullInProgress"] = "pull_in_progress";
    ConnectorHealthStatus["Critical"] = "critical";
    ConnectorHealthStatus["Recovering"] = "recovering";
    ConnectorHealthStatus["Healthy"] = "healthy";
    ConnectorHealthStatus["Stale"] = "stale";
})(ConnectorHealthStatus = exports.ConnectorHealthStatus || (exports.ConnectorHealthStatus = {}));
var DetailedConnectorRequestFormFields;
(function (DetailedConnectorRequestFormFields) {
    DetailedConnectorRequestFormFields["Email"] = "emailAddress";
    DetailedConnectorRequestFormFields["Environment"] = "entry.1410228922";
    DetailedConnectorRequestFormFields["Reason"] = "entry.939579656";
    DetailedConnectorRequestFormFields["Connector"] = "entry.1595945438";
    DetailedConnectorRequestFormFields["Why"] = "entry.139208238";
    DetailedConnectorRequestFormFields["Other"] = "entry.1595945438.other_option_response";
})(DetailedConnectorRequestFormFields = exports.DetailedConnectorRequestFormFields || (exports.DetailedConnectorRequestFormFields = {}));
//# sourceMappingURL=enums.js.map